<template>
    <q-layout view="lHr lpr fFf">
        <q-header class="bg-white">
            <div class="q-pa-lg">
                <q-tabs align="right" no-caps active-color="text-white" indicator-color="primary" active-bg-color="secondary"
                        v-model="tab"  class="text-primary">
                    <q-route-tab name="about" label="About" :to="{name: 'home'}"/>
                    <q-route-tab name="services" label="Services" :to="{name: 'services'}"/>
                    <q-route-tab name="contact" label="Contact" :to="{name: 'contact'}"/>
                </q-tabs>
            </div>
        </q-header>

        <q-footer reveal class="bg-black">
            <q-toolbar>
                <q-toolbar-title class="CentGothWGL text-center">
                  <span class="FrenchKiss-Bold q-ma-md">The Black Cat</span> Company
                </q-toolbar-title>
            </q-toolbar>
        </q-footer>

        <q-page-container>
            <router-view/>
        </q-page-container>
    </q-layout>
</template>

<script>
    export default {
        name: 'LayoutDefault',

        components: {

        },

        data() {
            return {
                tab: "about"
            }
        }
    }
</script>

<style>
</style>
